/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_Matrix_LeadInputs */

const en_mk_cmp_page_matrix_lead = /** @type {(inputs: Mk_Cmp_Page_Matrix_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As far as we know from Multica's public documentation, as of 6 September 2026.`)
};

const id_mk_cmp_page_matrix_lead = /** @type {(inputs: Mk_Cmp_Page_Matrix_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sepengetahuan kami dari dokumentasi publik Multica, per 6 September 2026.`)
};

/**
* | output |
* | --- |
* | "As far as we know from Multica's public documentation, as of 6 September 2026." |
*
* @param {Mk_Cmp_Page_Matrix_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_matrix_lead = /** @type {((inputs?: Mk_Cmp_Page_Matrix_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_Matrix_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_matrix_lead(inputs)
	return en_mk_cmp_page_matrix_lead(inputs)
});